import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContactsFormStep1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 604 736",
	width: "100%",
	height: "100%",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "a",
		width: 605,
		height: 736,
		x: 0,
		y: 0,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "alpha" },
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#D8ECFF",
			d: "M0 0h604.001v736H0z"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		stroke: "#0669FD",
		strokeMiterlimit: 10,
		strokeOpacity: .3,
		strokeWidth: 1.5,
		mask: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M267.12 63.93s174.174 673-208.07 673" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c362.135 0 232.72-637.61 232.72-637.61" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c342.025 0 257.338-602.184 257.338-602.184" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c321.916 0 281.989-566.757 281.989-566.757" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c301.774 0 306.639-531.33 306.639-531.33" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c281.664 0 331.29-495.903 331.29-495.903" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c261.555 0 355.94-460.476 355.94-460.476" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c241.413 0 380.59-425.049 380.59-425.049" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c221.303 0 405.208-389.622 405.208-389.622" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c201.194 0 429.859-354.195 429.859-354.195" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c181.084 0 454.509-318.806 454.509-318.806" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c160.942 0 479.16-283.379 479.16-283.379" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c140.833 0 503.81-247.952 503.81-247.952" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c120.723 0 528.46-212.525 528.46-212.525" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c100.581 0 553.111-177.098 553.111-177.098" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c80.471 0 577.729-141.671 577.729-141.671" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c60.362 0 602.379-106.244 602.379-106.244" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c40.252 0 627.03-70.817 627.03-70.817" }),
			/* @__PURE__ */ _jsx("path", { d: "M59.05 736.93c20.11 0 651.68-35.39 651.68-35.39" })
		]
	})]
});
export default SvgContactsFormStep1;
